import axios from 'axios';
import { loginreq, reqpost, reqget } from './axiosFun';

// 登录接口
export const login = (params) => { return reqpost("post", "/api/login/login", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 用户管理
 **/
// 用户管理-获取用户列表
// export const userList = (params) => { return req("post", "/api/User/list", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", "/api/User/save", params) };
// 用户管理-删除用户
// export const userDelete = (params) => { return axios.delete("/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/api/User/pwd", params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/api/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/api/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", "/api/Module/list") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/api/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/api/Module/save", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete("/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理
 **/
// 角色管理-获取角色列表
// export const roleList = (params) => { return req("post", "/api/Role/list", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", "/api/Role/save", params) };
// 角色管理-删除角色
// export const roleDelete = (params) => { return axios.delete("/api/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get("/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };

/**
 * 公司管理
 **/
// 公司管理-获取公司列表
export const deptList = (params) => { return req("get", "/platform-nick-name-check/getList", params) };
// 公司管理-保存（添加编辑）
export const deptSave = (params) => { return req("post", "/api/Dept/save", params) };



export const noticeGetList = (params) => { return req("get", "/api/notice/getList", params) };





// export const
// 公司管理-删除公司
export const deptDelete = (params) => { return axios.get("/api/Dept/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// export const noticeGetList = (params) => { return axios.get("/api/notice/getList"+ params).then(res => res.data) };
/**
 * 系统环境变量
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };



export const roleAdd = (params) => { return reqpost("post", "/api/role/add", params) };//添加角色
export const roleList = (params) => { return reqget("get", "/api/role/list",params) };//角色列表
export const roleDelete = (params) => { return reqpost("post", "/api/role/delete",params) };//删除角色
export const roleEdit = (params) => { return reqpost("post", "/api/role/edit",params) };//编辑角色角色



export const userList = (params) => { return reqget("get", "/api/user/list",params) };//人员列表
export const userDelete = (params) => { return reqpost("post", "/api/user/delete",params) };//删除人员账号
export const userAdd = (params) => { return reqpost("post", "/api/user/add", params) };//添加人员信息
export const userEdit = (params) => { return reqpost("post", "/api/user/edit",params) };//编辑人员信息




export const getListByRole = (params) => { return reqget("get", "/api/menu/getListByRole",params) };//获取角色目录列表
export const getMenuList = (params) => { return reqget("get", "/api/menu/getMenuList",params) };//获取菜单列表
export const menuAdd = (params) => { return reqpost("post", "/api/menu/add",params) };//新增菜单列表
export const getParentList = (params) => { return reqget("get", "/api/menu/getParentList",params) };//新增菜单列表
export const menuList = (params) => { return reqpost("post", "/api/menu/edit",params) };//新增菜单列表
export const menuEdit = (params) => { return reqpost("post", "/api/role-menu/edit",params) };//新增菜单列表

export const getListByUser = (params) => { return reqget("get", "/api/menu/getListByUser",params) };//新增菜单列表

export const menuDelete = (params) => { return reqpost("post", "/api/menu/delete",params) };//新增菜单列表
export const getAllData = (params) => { return reqget("get", "/api/dataPanel/getAllData",params) };//新增菜单列表
export const getTodayData = (params) => { return reqget("get", "/api/dataPanel/getTodayData",params) };//新增菜单列表
export const addressRegister = (params) => { return reqget("get", "/api/dataPanel/addressRegister",params) };//地区注册

export const channelRegister = (params) => { return reqget("get", "/api/dataPanel/channelRegister",params) };//地区注册





export const settingdelete = (params) => { return reqpost("post", "/api/protocol-setting/delete",params) };//新增菜单列表

export const getDynamicList = (params) => { return reqget("get", "/api/dynamic/getDynamicList",params) };//地区注册


export const blockDynamic = (params) => { return reqpost("post", "/api/dynamic-report/handleDynamic",params) };//地区注册
export const reportBlockDynamic = (params) => { return reqpost("post", "/api/dynamic-report/blockDynamic",params) };//地区注册
export const deleteSysDynamic = (params) => { return reqpost("post", "/api/dynamic/deleteSysDynamic",params) };//地区注册

export const platformAccount = (params) => { return reqpost("post", "/api/platform-account/block",params) };//地区注册

export const joinVipClubFree = (params) => { return reqpost("post", "/api/vipClub/joinVipClubFree",params) };//加入精英俱乐部(手动)

export const insertVipClubPriceConfig = (params) => { return reqpost("post", "/api/vipClub/insertVipClubPriceConfig",params) };//新增精英俱乐部价格配置



export const updateVipClubPriceConfig = (params) => { return reqpost("post", "/api/vipClub/updateVipClubPriceConfig",params) };//修改精英俱乐部价格配置
export const getVipClubNewPrice = (params) => { return reqget("get", "/api/vipClub/getVipClubNewPrice",params) };//获取当前精英俱乐部价格

export const getMiniAppJumpUrlSwitch = (params) => { return reqget("get", "/api/system-config/getMiniAppJumpUrlSwitch",params) };//获取登录/注册小程序跳转路径
export const updateMiniAppJumpUrlSwitch = (params) => { return reqpost("post", "/api/system-config/updateMiniAppJumpUrlSwitch",params) };//修改登录/注册小程序跳转路径开关
export const getRefundList = (params) => { return reqget("get", "/api/orders/getRefundList",params) };//获取可退款订单列表
export const getteacherList = (params) => { return reqget("get", "/api/teacher/teacherList",params) };//获取导师列表









// WEBPACK FOOTER //
// ./src/api/userMG.js